<script>
import { useThemeStore } from '@/stores/themeStore';

export default {
   setup() {
      const themeStore = useThemeStore();
      themeStore.initTheme()

      return {
         toggleTheme: themeStore.toggleTheme,
      }
   },
}
</script>

<template>
   <button id="app_theme_button" @click="toggleTheme" class="button-test">Переключить тему</button>
</template>

<style scoped>
.button-test {
   position: fixed;
   z-index: 122;
   color: #888888;
   top: 0;
   width: 196px;
   height: 35px;
   display: none;
}
</style>